import type { LaunchLocale } from "../../locales/src/locales";
const financial = {
  en: {
    reserved: "Reserved",
    payable: "Payable",
    transferred: "Transferred",
    bankPending: "Bank confirmation pending",
    bankPaid: "Paid by bank",
  },
  es: {
    reserved: "Reservado",
    payable: "Por pagar",
    transferred: "Transferido",
    bankPending: "Confirmación bancaria pendiente",
    bankPaid: "Pagado por el banco",
  },
  fr: {
    reserved: "Réservé",
    payable: "À payer",
    transferred: "Transféré",
    bankPending: "Confirmation bancaire en attente",
    bankPaid: "Payé par la banque",
  },
  de: {
    reserved: "Reserviert",
    payable: "Auszahlbar",
    transferred: "Überwiesen",
    bankPending: "Bankbestätigung ausstehend",
    bankPaid: "Von der Bank ausgezahlt",
  },
  ja: {
    reserved: "予約済み",
    payable: "支払対象",
    transferred: "送金済み",
    bankPending: "銀行の確認待ち",
    bankPaid: "銀行の支払完了",
  },
} satisfies Record<LaunchLocale, Record<string, string>>;
/** Rendering only: preserve the server's separate states; never infer settlement from transfer. */
export function financialState(locale: LaunchLocale, state: string): string {
  const key =
    state === "bank-pending"
      ? "bankPending"
      : state === "bank-paid"
        ? "bankPaid"
        : state;
  return Object.hasOwn(financial[locale], key)
    ? financial[locale][key as keyof typeof financial.en]
    : state;
}
